export const COLOR_GROUPS_RAW = {
  white: {
    border: 'border-white',
    text: 'text-white',
    bg: 'bg-white',
    divider: 'divide-white'
  },
  light: {
    ring: 'ring-slate-600/40',
    border: 'border-slate-400/10',
    text: 'text-slate-300',
    bg: 'bg-slate-50',
    divider: 'divide-slate-400/10'
  },
  default: {
    ring: 'ring-slate-600/40',
    border: 'border-slate-200',
    text: 'text-slate-600',
    bg: 'bg-slate-100',
    divider: 'divide-slate-200'
  },
  slate: {
    ring: 'ring-slate-600/40',
    border: 'border-slate-500/10',
    text: 'text-slate-600',
    bg: 'bg-slate-50',
    divider: 'divide-slate-500/10'
  },
  red: {
    ring: 'ring-red-600/40',
    border: 'border-red-600/10',
    text: 'text-red-700',
    bg: 'bg-red-50',
    divider: 'divide-slate-600/10'
  },
  yellow: {
    ring: 'ring-yellow-600/40',
    border: 'border-yellow-600/20',
    text: 'text-yellow-600',
    bg: 'bg-yellow-50',
    divider: 'divide-yellow-600/20'
  },
  amber: {
    ring: 'ring-amber-600/40',
    border: 'border-amber-600/20',
    text: 'text-amber-600',
    bg: 'bg-amber-50',
    divider: 'divide-amber-600/20'
  },
  green: {
    ring: 'ring-green-600/40',
    border: 'border-green-600/20',
    text: 'text-green-700',
    bg: 'bg-green-50',
    divider: 'divide-green-600/20'
  },
  blue: {
    ring: 'ring-blue-600/40',
    border: 'border-blue-700/20',
    text: 'text-blue-700',
    bg: 'bg-blue-50',
    divider: 'divide-blue-600/20'
  },
  indigo: {
    ring: 'ring-indigo-600/40',
    border: 'border-indigo-700/10',
    text: 'text-indigo-700',
    bg: 'bg-indigo-50',
    divider: 'divide-indigo-600/20'
  },
  purple: {
    ring: 'ring-purple-600/40',
    border: 'border-purple-700/10',
    text: 'text-purple-700',
    bg: 'bg-purple-50',
    divider: 'divide-purple-600/20'
  },
  pink: {
    ring: 'ring-pink-600/40',
    border: 'border-pink-700/10',
    text: 'text-pink-700',
    bg: 'bg-pink-50',
    divider: 'divide-pink-600/20'
  }
};
